import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5da1b963")

_pushScopeId("data-v-5da1b963")
const _hoisted_1 = {
  key: 0,
  class: "company-right flex flex--valign-c flex--gap-20"
}
const _hoisted_2 = { class: "company-right-rating-text text text--primary-b text--uppercase text--size-20 text--semi-bold text--right" }
const _hoisted_3 = { class: "flex flex--height flex--valign-c" }
const _hoisted_4 = { class: "company-right-plane-text text text--color-white text--shadow text--size-40 text--semi-bold" }
const _hoisted_5 = { class: "flex flex--height flex--valign-c" }
const _hoisted_6 = { class: "text text--color-white text--shadow text--size-22 text--semi-bold" }
const _hoisted_7 = { class: "company-body" }
const _hoisted_8 = { class: "company-left" }
const _hoisted_9 = { class: "flex flex--width flex--valign-c flex--halign-c" }
const _hoisted_10 = { class: "square-logo flex flex--valign-c flex--halign-c" }
const _hoisted_11 = { class: "flex flex--height flex--valign-c" }
const _hoisted_12 = { class: "text text--color-white text--shadow text--size-24 text--semi-bold" }
const _hoisted_13 = {
  key: 0,
  class: "company-rating-mobile flex flex--valign-c flex--halign-sb"
}
const _hoisted_14 = { class: "text text--primary-b text--uppercase text--size-20 text--semi-bold text--left" }
const _hoisted_15 = { class: "flex flex--height flex--valign-c" }
const _hoisted_16 = { class: "company-rating-mobile-plane-text text text--color-white text--shadow text--size-40 text--semi-bold" }
const _hoisted_17 = { class: "company-card-content" }
const _hoisted_18 = { class: "economic-sectors flex flex--wrap flex--gap-15" }
const _hoisted_19 = { class: "flex flex--width flex--v flex--valign-c flex--gap-30" }
const _hoisted_20 = { class: "company-info-plane-wrapper flex flex--width flex--wrap flex--gap-30 flex--halign-c" }
const _hoisted_21 = { class: "flex flex--v flex--valign-c flex--gap-15" }
const _hoisted_22 = { class: "text text--uppercase text--primary-b text--size-20 text--medium text--center text--less-gap" }
const _hoisted_23 = { class: "text text--accent-gray-b text--size-18 text--regular text--center text--height-24" }
const _hoisted_24 = {
  key: 0,
  class: "company-info-bottom flex flex--width flex--halign-sb flex--valign-e flex--gap-30"
}
const _hoisted_25 = { class: "company-info-bottom-left flex flex--v flex--gap-10 flex--valign-s" }
const _hoisted_26 = { class: "company-info-bottom-left-text text text--uppercase text--primary-b text--size-20 text--medium text--left text--less-gap" }
const _hoisted_27 = {
  key: 0,
  class: "company-info-bottom-right flex flex--v flex--gap-10 flex--valign-e"
}
const _hoisted_28 = { class: "company-info-bottom-right-content-text text text--accent-gray-b text--size-20 text--medium text--right text--less-gap" }
const _hoisted_29 = { class: "flex flex--v flex--valign-c flex--gap-30" }
const _hoisted_30 = { class: "flex flex--v flex--valign-c flex--gap-15" }
const _hoisted_31 = { class: "text text--uppercase text--primary-b text--size-20 text--medium text--center text--less-gap" }
const _hoisted_32 = { class: "company-extras-plane-text text text--accent-gray-b text--size-18 text--regular text--center text--height-24" }
const _hoisted_33 = {
  key: 0,
  class: "company-info-bottom flex flex--width flex--halign-sb flex--valign-e flex--gap-30"
}
const _hoisted_34 = { class: "company-info-bottom-left flex flex--v flex--gap-10 flex--valign-s" }
const _hoisted_35 = { class: "company-info-bottom-left-text text text--uppercase text--primary-b text--size-20 text--medium text--left text--less-gap" }
const _hoisted_36 = {
  key: 0,
  class: "company-info-bottom-right flex flex--v flex--gap-10 flex--valign-e"
}
const _hoisted_37 = { class: "company-info-bottom-right-content-text text text--accent-gray-b text--size-20 text--medium text--right text--less-gap" }
const _hoisted_38 = { class: "flex flex--width flex--v flex--valign-c flex--gap-30" }
const _hoisted_39 = { class: "company-contact-info-wrapper flex flex--width flex--valign-c flex--halign-c flex--gap-30" }
const _hoisted_40 = { class: "flex--extend flex flex--v flex--valign-c flex--halign-c flex--gap-30" }
const _hoisted_41 = { class: "text text--uppercase text--primary-b text--size-20 text--medium text--center text--less-gap" }
const _hoisted_42 = { class: "text text--accent-gray-b text--size-18 text--regular text--center text--height-24" }
const _hoisted_43 = { class: "company-info-bottom flex flex--width flex--halign-sb flex--valign-e flex--gap-30" }
const _hoisted_44 = { class: "company-info-bottom-left flex flex--v flex--gap-10 flex--valign-s" }
const _hoisted_45 = { class: "company-info-bottom-left-text text text--uppercase text--primary-b text--size-20 text--medium text--left text--less-gap" }
const _hoisted_46 = {
  key: 0,
  class: "company-info-bottom-right flex flex--v flex--gap-10 flex--valign-e"
}
const _hoisted_47 = { class: "company-info-bottom-right-content-text text text--accent-gray-b text--size-20 text--medium text--right text--less-gap" }
const _hoisted_48 = { class: "flex flex--v flex--valign-c text text--size-18 text--height-24 text--primary-b text--medium text--center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Plane = _resolveComponent("Plane")
  const _component_GenericButton = _resolveComponent("GenericButton")
  const _component_FindCompanySkills = _resolveComponent("FindCompanySkills")
  const _component_Icon = _resolveComponent("Icon")
  const _component_GenericModal = _resolveComponent("GenericModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.company)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          id: `company-card-${_ctx.company.id}`,
          class: "flex flex--v flex--width flex--gap-30"
        }, [
          _createVNode(_component_Plane, {
            class: ["company-card", { 'more-info': _ctx.moreInfo }]
          }, {
            default: _withId(() => [
              (!_ctx.company.withoutRating && !isNaN(_ctx.company.rating))
                ? (_openBlock(), _createBlock("div", _hoisted_1, [
                    _createVNode("span", _hoisted_2, _toDisplayString(_ctx.$trans("company.rating")), 1),
                    _createVNode(_component_Plane, {
                      class: "company-right-plane",
                      primary: true
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_3, [
                          _createVNode("span", _hoisted_4, _toDisplayString(`${(_ctx.company.rating * 100).toFixed(2)}%`), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.company.occupation)
                ? (_openBlock(), _createBlock(_component_Plane, {
                    key: 1,
                    class: "company-occupation-plane company-left-plane company-left-plane--secondary",
                    secondary: true
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_5, [
                        _createVNode("span", _hoisted_6, _toDisplayString(_ctx.company.occupation), 1)
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  (_ctx.company.image)
                    ? (_openBlock(), _createBlock(_component_Plane, {
                        key: 0,
                        class: "company-left-plane company-left-plane--logo"
                      }, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_9, [
                            _createVNode("div", _hoisted_10, [
                              _createVNode("img", {
                                src: _ctx.company.image.imageUrl,
                                alt: _ctx.$trans('company.image_alt')
                              }, null, 8, ["src", "alt"])
                            ])
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_Plane, {
                    class: "company-left-plane company-left-plane--primary",
                    primary: true
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_11, [
                        _createVNode("span", _hoisted_12, _toDisplayString(_ctx.company.name), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                (!_ctx.company.withoutRating && !isNaN(_ctx.company.rating))
                  ? (_openBlock(), _createBlock("div", _hoisted_13, [
                      _createVNode("span", _hoisted_14, _toDisplayString(_ctx.$trans("company.rating")), 1),
                      _createVNode(_component_Plane, {
                        class: "company-rating-mobile-plane",
                        primary: true
                      }, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_15, [
                            _createVNode("span", _hoisted_16, _toDisplayString(`${(_ctx.company.rating * 100).toFixed(2)}%`), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_17, [
                  _createVNode("div", _hoisted_18, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.company.sectors, (sector) => {
                      return (_openBlock(), _createBlock("div", {
                        key: sector.id,
                        class: "economic-sector text text--primary-b text--uppercase text--size-20 text--bold",
                        onClick: ($event: any) => (_ctx.openModal(sector.name))
                      }, _toDisplayString(_ctx.$trans(`company.${sector.name}`)), 9, ["onClick"]))
                    }), 128))
                  ]),
                  (_ctx.company.description)
                    ? (_openBlock(), _createBlock("span", {
                        key: 0,
                        class: ["company-description text text--accent-gray-b text--size-18 text--height-24 text--medium", { 'text--line-clamp-3': !_ctx.moreInfo }]
                      }, _toDisplayString(_ctx.company.description), 3))
                    : _createCommentVNode("", true)
                ])
              ]),
              (!_ctx.moreInfo)
                ? (_openBlock(), _createBlock(_component_GenericButton, {
                    key: 2,
                    class: "more-info-button",
                    title: _ctx.$trans('company.button_more_info'),
                    circular: true,
                    onClick: _ctx.onClickDetails
                  }, null, 8, ["title", "onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class"]),
          (_ctx.moreInfo)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_FindCompanySkills, {
                  "qualification-groups": _ctx.qualificationGroups,
                  "qualification-input": _ctx.qualificationInput,
                  "company-requirements": _ctx.company.requirements,
                  "is-company": true
                }, null, 8, ["qualification-groups", "qualification-input", "company-requirements"]),
                _createVNode(_component_Plane, { class: "company-info" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_19, [
                      _createVNode("div", _hoisted_20, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.companyInfoBlocks, (info) => {
                          return (_openBlock(), _createBlock(_component_Plane, {
                            key: info.title,
                            class: "company-info-plane"
                          }, {
                            default: _withId(() => [
                              _createVNode("div", _hoisted_21, [
                                _createVNode("span", _hoisted_22, _toDisplayString(info.title), 1),
                                _createVNode("span", _hoisted_23, _toDisplayString(info.content), 1)
                              ])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      (!_ctx.company.internship_extras && !_ctx.company.contact)
                        ? (_openBlock(), _createBlock("div", _hoisted_24, [
                            _createVNode("div", _hoisted_25, [
                              _createVNode("span", _hoisted_26, _toDisplayString(_ctx.company.name), 1),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.companyInfoLeft, (info) => {
                                return (_openBlock(), _createBlock("span", {
                                  key: info,
                                  class: "company-info-bottom-left-text text text--accent-gray-b text--size-20 text--medium text--left text--less-gap"
                                }, _toDisplayString(info), 1))
                              }), 128))
                            ]),
                            (_ctx.companyInfoRight.length > 0)
                              ? (_openBlock(), _createBlock("div", _hoisted_27, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.companyInfoRight, (info) => {
                                    return (_openBlock(), _createBlock("div", {
                                      key: info.info,
                                      class: "company-info-bottom-right-content flex flex--valign-c flex--gap-10"
                                    }, [
                                      _createVNode(_component_Icon, {
                                        class: "company-info-bottom-right-content-icon",
                                        identifier: info.icon
                                      }, null, 8, ["identifier"]),
                                      _createVNode("span", _hoisted_28, _toDisplayString(info.info), 1)
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                (!!_ctx.company.internship_extras)
                  ? (_openBlock(), _createBlock(_component_Plane, {
                      key: 0,
                      class: "company-extras"
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_29, [
                          _createVNode(_component_Plane, { class: "company-extras-plane" }, {
                            default: _withId(() => [
                              _createVNode("div", _hoisted_30, [
                                _createVNode("span", _hoisted_31, _toDisplayString(_ctx.$trans("company.internship_extras")), 1),
                                _createVNode("span", _hoisted_32, _toDisplayString(_ctx.companyExtrasText), 1)
                              ])
                            ]),
                            _: 1
                          }),
                          (!_ctx.company.contact)
                            ? (_openBlock(), _createBlock("div", _hoisted_33, [
                                _createVNode("div", _hoisted_34, [
                                  _createVNode("span", _hoisted_35, _toDisplayString(_ctx.company.name), 1),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.companyInfoLeft, (info) => {
                                    return (_openBlock(), _createBlock("span", {
                                      key: info,
                                      class: "company-info-bottom-left-text text text--accent-gray-b text--size-20 text--medium text--left text--less-gap"
                                    }, _toDisplayString(info), 1))
                                  }), 128))
                                ]),
                                (_ctx.companyInfoRight.length > 0)
                                  ? (_openBlock(), _createBlock("div", _hoisted_36, [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.companyInfoRight, (info) => {
                                        return (_openBlock(), _createBlock("div", {
                                          key: info.info,
                                          class: "company-info-bottom-right-content flex flex--valign-c flex--gap-10"
                                        }, [
                                          _createVNode(_component_Icon, {
                                            class: "company-info-bottom-right-content-icon",
                                            identifier: info.icon
                                          }, null, 8, ["identifier"]),
                                          _createVNode("span", _hoisted_37, _toDisplayString(info.info), 1)
                                        ]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.company.contact)
                  ? (_openBlock(), _createBlock(_component_Plane, {
                      key: 1,
                      class: "company-contact"
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_38, [
                          _createVNode("div", _hoisted_39, [
                            (_ctx.company.image_contact)
                              ? (_openBlock(), _createBlock(_component_Plane, {
                                  key: 0,
                                  class: "company-contact-image"
                                }, {
                                  default: _withId(() => [
                                    _createVNode("img", {
                                      src: _ctx.company.image_contact.imageUrl,
                                      alt: _ctx.$trans('company.image_contact_alt')
                                    }, null, 8, ["src", "alt"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_Plane, { class: "company-contact-info" }, {
                              default: _withId(() => [
                                _createVNode("div", _hoisted_40, [
                                  _createVNode("span", _hoisted_41, _toDisplayString(_ctx.$trans("company.contact")), 1),
                                  _createVNode("span", _hoisted_42, _toDisplayString(_ctx.company.contact), 1)
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createVNode("div", _hoisted_43, [
                            _createVNode("div", _hoisted_44, [
                              _createVNode("span", _hoisted_45, _toDisplayString(_ctx.company.name), 1),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.companyInfoLeft, (info) => {
                                return (_openBlock(), _createBlock("span", {
                                  key: info,
                                  class: "company-info-bottom-left-text text text--accent-gray-b text--size-20 text--medium text--left text--less-gap"
                                }, _toDisplayString(info), 1))
                              }), 128))
                            ]),
                            (_ctx.companyInfoRight.length > 0)
                              ? (_openBlock(), _createBlock("div", _hoisted_46, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.companyInfoRight, (info) => {
                                    return (_openBlock(), _createBlock("div", {
                                      key: info.info,
                                      class: "company-info-bottom-right-content flex flex--valign-c flex--gap-10"
                                    }, [
                                      _createVNode(_component_Icon, {
                                        class: "company-info-bottom-right-content-icon",
                                        identifier: info.icon
                                      }, null, 8, ["identifier"]),
                                      _createVNode("span", _hoisted_47, _toDisplayString(info.info), 1)
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ], 8, ["id"]))
      : _createCommentVNode("", true),
    (!!_ctx.modalOpenName)
      ? (_openBlock(), _createBlock(_component_GenericModal, {
          key: 1,
          onClosed: _ctx.closeModal
        }, {
          title: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$trans(`company.${_ctx.modalOpenName}`)), 1)
          ]),
          content: _withId(() => [
            _createVNode("div", _hoisted_48, _toDisplayString(_ctx.$trans(`company.${_ctx.modalOpenName}_desc`)), 1)
          ]),
          _: 1
        }, 8, ["onClosed"]))
      : _createCommentVNode("", true)
  ], 64))
})